// src/js/controllers/tracker_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { entryId: Number }
  connect() {
    this.timerEl = document.getElementById('live-timer');
    this.running = !!this.entryIdValue;
    if (this.running) {
      // start ticking from server-provided duration (we show server value initially)
      this.startTick();
    }
  }

  // helper: get CSRF token
  csrfToken() {
    const m = document.querySelector('meta[name="csrf-token"]');
    return m ? m.getAttribute('content') : '';
  }

  start(event) {
    event && event.preventDefault();
    const desc = document.getElementById('tracker-desc')?.value || '';
    const proj = document.getElementById('tracker-project')?.value || '';

    fetch('/time_tracker/start_timer', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': this.csrfToken() },
      body: JSON.stringify({ description: desc, project_id: proj })
    }).then(r => r.json()).then(data => {
      if (data.status === 'ok' && data.id) {
        this.entryIdValue = data.id;
        this.running = true;
        this.startTick();
        // optionally reload to show entry in list
        location.reload();
      } else {
        console.error('start failed', data);
      }
    });
  }

  stop(event) {
    event && event.preventDefault();
    const id = event?.target?.dataset?.entryId || this.entryIdValue;
    if (!id) return;

    fetch('/time_tracker/stop_timer', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': this.csrfToken() },
      body: JSON.stringify({ id })
    }).then(r => r.json()).then(data => {
      if (data.status === 'ok') {
        this.running = false;
        // reload to update display
        location.reload();
      } else {
        console.error('stop failed', data);
      }
    });
  }

  resume(event) {
    event && event.preventDefault();
    const id = event.target.dataset.entryId;
    // implement resume if you support it: create new start referencing previous description
    // For now, call start with description pulled from row (server-side mapping recommended)
    fetch('/time_tracker/start_timer', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': this.csrfToken() },
      body: JSON.stringify({ resume_from_id: id })
    }).then(r => r.json()).then(data => {
      if (data.status === 'ok') {
        location.reload();
      } else console.error('resume failed', data);
    });
  }

  // live ticking (simple)
  startTick() {
    // read current text (format HH:MM:SS) and convert to seconds
    const parse = (s) => {
      const parts = String(s || '00:00:00').split(':').map(n => parseInt(n,10) || 0);
      return parts[0]*3600 + parts[1]*60 + parts[2];
    }
    let seconds = parse(this.timerEl?.innerText);
    if (!this.timerInterval) {
      this.timerInterval = setInterval(() => {
        seconds += 1;
        const h = Math.floor(seconds/3600).toString().padStart(2,'0');
        const m = Math.floor((seconds%3600)/60).toString().padStart(2,'0');
        const s = Math.floor(seconds%60).toString().padStart(2,'0');
        if (this.timerEl) this.timerEl.innerText = `${h}:${m}:${s}`;
      }, 1000);
    }
  }

  disconnect() {
    if (this.timerInterval) clearInterval(this.timerInterval);
  }
}
